import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { logout } from 'domains/Auth';
import dashboardService from '../../services';
import { initialState } from '../constants';

export const getOnboardingAction = createAsyncThunk(
  'dashboard/getOnboardingTasksAction',
  ({ isMobile }: { isMobile: boolean }) =>
    dashboardService.getOnboardingTasks(isMobile),
);

export const updateOnboardingTaskSetupPaymentsAction = createAsyncThunk(
  'dashboard/updateOnboardingTaskSetupPaymentsAction',
  dashboardService.updateOnboardingTaskSetupPayments,
);

export const updateOnboardingTaskStatusAction = createAsyncThunk(
  'dashboard/updateOnboardingTaskStatusAction',
  dashboardService.updateOnboardingTaskStatus,
);

export const createOnboardingAction = createAsyncThunk(
  'dashboard/createOnboardingAction',
  dashboardService.createOnboarding,
);

const onboardingSlice = createSlice({
  name: 'onboardingSlice',
  initialState: initialState.onboarding,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, (state) => {
      state = initialState.onboarding;
      return state;
    });

    builder
      .addCase(getOnboardingAction.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getOnboardingAction.rejected, (state) => {
        state.status = 'error';
      })
      .addCase(getOnboardingAction.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload;
      })
      .addCase(createOnboardingAction.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(createOnboardingAction.rejected, (state) => {
        state.create.status = 'error';
      })
      .addCase(createOnboardingAction.fulfilled, (state, action) => {
        state.create.status = 'success';
        state.data = action.payload;
      });
  },
});

export const { reducer } = onboardingSlice;
